import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  LINK: `${cleanedFilename(__filename)}-link`,
  CLOSE_BUTTON: `${cleanedFilename(__filename)}-close`,
  TOAST_MESSAGE: `${cleanedFilename(__filename)}-toast-message`,
};
